var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingRoomValves = function SvgDCoolingRoomValves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.01,
    y: 249,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 262,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "210 264.01 217.15 276.49 202.87 276.5 210 264.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,265.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M210,263l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.87 249.51 217.15 249.5 210 261.99 202.87 249.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.28,250l-6.29,10.98-6.26-10.98h12.55M218.01,249h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 189.02,
    cy: 263,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.02,253c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M189.02,252c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,260.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 249,
    width: 10,
    height: 27.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.01,
    y: 261.99,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "403.99 264 411.14 276.47 396.87 276.48 403.99 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.99,265l6.28,10.96h-12.55s6.26-10.96,6.26-10.96M403.99,262.99l-7.98,13.99h15.99s-8.01-13.99-8.01-13.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "396.87 249.51 411.14 249.5 403.99 261.98 396.87 249.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.27,250l-6.28,10.97-6.26-10.97h12.55M412,249h-15.99s7.98,13.99,7.98,13.99l8.01-13.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 383.01,
    cy: 262.99,
    r: 10.99,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.01,253c5.51,0,9.99,4.48,9.99,9.99s-4.48,9.99-9.99,9.99-9.99-4.48-9.99-9.99,4.48-9.99,9.99-9.99M383.01,252c-6.07,0-10.99,4.92-10.99,10.99s4.92,10.99,10.99,10.99,10.99-4.92,10.99-10.99-4.92-10.99-10.99-10.99h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,260.14v5.68h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.37h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.68h1.28s1.64,4.35,1.64,4.35l1.64-4.35h1.28Z"
  })))));
};
export default SvgDCoolingRoomValves;